import { useTranslation } from 'react-i18next';

import { Form, Formik } from 'formik';

import { SingleSelect } from '@/common';
import { FilterModalLayout, FilterPopUpValues } from '@/components/layouts';
import { getTributeVideoExportStatusOptions } from '@/helpers';
import { FilterDashboardProps, SelectOptionProps } from '@/types';

export const DashboardFilters = ({
  onClose,
  reset,
  apply,
  filterByStatus,
  buttonPosition
}: FilterDashboardProps) => {
  const [t] = useTranslation('common');

  return (
    <Formik
      initialValues={{
        filterByStatus: filterByStatus ?? null
      }}
      onSubmit={() => undefined}>
      {({ setFieldValue, values }) => (
        <Form>
          <FilterModalLayout
            apply={apply as (values: FilterPopUpValues) => void}
            reset={reset}
            onClose={onClose}
            values={values}
            position={buttonPosition}
            isDashboardPage>
            <SingleSelect
              isClearable
              placeholder={t('selectStatus')}
              id='filterByStatus'
              label={t('status')}
              options={getTributeVideoExportStatusOptions()}
              handleChange={(value) => setFieldValue('filterByStatus', value as SelectOptionProps)}
              value={values.filterByStatus}
            />
          </FilterModalLayout>
        </Form>
      )}
    </Formik>
  );
};
